import React from "react";
import {Typography} from "@mui/material";
import {FormattedMessage} from "react-intl";
import {
    useGetSoccerPlayerSeasonStatsByPlayerIdQuery,
} from "../../../stores/tradefan/tradefan.api";

import "../SeasonStats.style.scss";

const renderPlayerSeasonStats = (data) => {
    return <div className="seasonStats">
                <div className="statItem">
                    <div>{data.GamesPlayed}</div>
                    <div>GP</div>
                </div>
                <div className="statItem">
                    <div>{data.Goals}</div>
                    <div>G</div>
                </div>
                <div className="statItem">
                    <div>{data.Assists}</div>
                    <div>A</div>
                </div>
                <div className="statItem">
                    <div>{data.Shots}</div>
                    <div>SH</div>
                </div>
                <div className="statItem">
                    <div>{data.ShotsOnTarget}</div>
                    <div>ST</div>
                </div>
                <div className="statItem">
                    <div>{data.TotalPointsDraftedPG}</div>
                    <div>TPD/GM</div>
                </div>
            </div>
}

const renderGoalieSeasonStats = (data) => {
    return <div className="seasonStats">
        <div className="statItem">
            <div>{data.GamesPlayed}</div>
            <div>GP</div>
        </div>
        <div className="statItem">
            <div>{data.Wins}-{data.Losses}</div>
            <div>W-L</div>
        </div>
        <div className="statItem">
            <div>{data.CleanSheets}</div>
            <div>CS</div>
        </div>
        <div className="statItem">
            <div>{data.GoalsAgainst}</div>
            <div>GA</div>
        </div>
        <div className="statItem">
            <div>{data.Saves}</div>
            <div>SV</div>
        </div>
        <div className="statItem">
            <div>{data.SavesPG}</div>
            <div>SV/GM</div>
        </div>
    </div>
}

const SOCCERSeasonStats = ({playerId, seasonYears}) => {

    const {data} = useGetSoccerPlayerSeasonStatsByPlayerIdQuery({playerId, seasonYear: seasonYears[0]});
    const isGoalie = data?.Position === "G";

    return <div className="SOCCERSeasonStats">
        <Typography variant="h6" className="gameLogTitle">
            {seasonYears[0]} - {seasonYears[1]} <FormattedMessage id={"popUp.contestPreview.seasonStats"}/>
        </Typography>
        {data && isGoalie && renderGoalieSeasonStats(data)}
        {data && !isGoalie && renderPlayerSeasonStats(data)}
    </div>
}

export default SOCCERSeasonStats;